// Module
var code = "<header class=\"topbar\">\n  <app-container>\n    <app-menu />\n  </app-container>\n</header>\n";
// Exports
export default code;